module.exports = __webpack_public_path__ + "img/subtract.2f4fd9f9.svg";